{
  "CSAT": {
    "TITLE": "Ohodnoťte svou konverzaci",
    "PLACEHOLDER": "Řekněte nám více...",
    "RATINGS": {
      "POOR": "😞 Špatné",
      "FAIR": "😑 Ucházející",
      "AVERAGE": "😐 Průměrné",
      "GOOD": "😀 Dobré",
      "EXCELLENT": "😍 Vynikající"
    }
  }
}